import { Component, OnInit, ViewChild, TemplateRef, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { Router } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/internal/Subject';
import { HEC_CONSTANTS } from '../../../utilities/constants';
import { DashboardService } from '../../../views/pages/dashboard/services/dashboard.service';
import { ForeignEmbassyValidatorService } from '../../../views/pages/dashboard/services/foreign-embassy-validator.service';
import { TaskTypeService } from '../../../views/pages/admin-dashboard/services/task-type.service';
import { MatDialog } from '@angular/material';
import { SharedService } from '../../sharedServices/shared.service';

@Component({
	templateUrl: './admintask-list.component.html',
	styleUrls: ['admintask-list.component.scss'],
})
export class AdmintaskListComponent implements OnInit, OnDestroy {
	categoryList: any[] = [
		{label:'Master and Above',id:0},
		{label:'Bachelor',id:1},
		{label:'All',id:3}];
	public selectedCategory:any=3;
	errorMessage: string;
	isError: boolean = false;
	alertType: string;
	columns: Array<any> = new Array<any>();
	rows: Array<any> = new Array<any>();
	taskList: Array<any> = new Array<any>();
	public showList:boolean=false;se
	loading = false;
	filterColumns: Array<any> = ['applicationId'];
	public searchKeyword: any;
	public config: any = {
		itemsPerPage: 6,
		currentPage: 1,
		totalItems: 0
	};
	@ViewChild('actionsTemplate', { static: true }) actionsTemplate: TemplateRef<any>;
	private _onDestroy = new Subject<void>();

	constructor(private service: SharedService, private router: Router,private sharedServices:SharedService,
		private dashboardService: DashboardService, private foreignEmbassyValidator: ForeignEmbassyValidatorService,
		private taskTitleService:TaskTypeService,private matDialog: MatDialog,private cdr:ChangeDetectorRef) {
	}

	ngOnInit(): void {
		this.generateColumns();
		this.getTasks();
		this.isFocalPerson();
	}

	generateColumns(): void {
		this.columns = [
			{ name: 'applicationId', displayName: 'Application Id' },
			{ name: 'taskTitle', displayName: 'Task Title' },
			{ name: 'processAcronym', displayName: 'Process' },
			{ name: 'action', displayName: 'Action', cellTemplate: this.actionsTemplate, sorting: false }
		];
	}

	isFocalPerson() {
		this.dashboardService.isFocalPerson().subscribe(
			(res) => {
				if (res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK && res.data) {
					this.foreignEmbassyValidator.sendForeign(true);
				} else {
					this.foreignEmbassyValidator.sendForeign(false);

				}
			},
			(err) => {
			}
		)
	}

	// viewTask(row): void {
	// 	this.sharedServices
	// 	.openPopupDialog(
	// 		HEC_CONSTANTS.MESSGAES_LIST.DES_ADMIN.ADMIN_TITLE,HEC_CONSTANTS.MESSGAES_LIST.DES_ADMIN.CLAIM_TASK,HEC_CONSTANTS.ERROR_TYPES.warning
	// 	)
	// 	.then((res) => {
	// 		  if (res) {
	// 			if (row.processAcronym == HEC_CONSTANTS.ACRONYM_TYPES.LOCAL_DES) {
	// 				if (row.isClaimed) {
	// 					this.router.navigate(['des-admin/task-detail', row.applicationId, row.taskTitle]);
	// 				} else {
	// 					this.loading = true;
	// 					this.isError = false;
	// 					this.service.claimTask(row.taskTitle, row.applicationId)
	// 						.pipe(takeUntil(this._onDestroy))
	// 						.subscribe(response => {
	// 							this.loading = false;
	// 							if (response.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
	// 								this.taskTitleService.setTaskTitle(row.taskTitle)
	// 								this.router.navigate(['des-admin/task-detail', row.applicationId, row.taskTitle])
	// 							} else {
	// 								this.isError = true;
	// 								this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 								this.errorMessage = response.statusDescription;;
	// 							}
	// 						}, error => {
	// 							this.isError = true;
	// 							this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
	// 							this.errorMessage = HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR;
	// 							this.loading = false;
	// 						})
	// 				}
	// 			}
	// 		  }
	// 	  });

	// }

	getTasks() {
		this.loading = true;
		this.service.getTaskTrackingByCommonProfile()
			.pipe(takeUntil(this._onDestroy))
			.subscribe(response => {
				if (response.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK) {
					if (response.data && response.data.tasksDto) {
						this.rows = response.data.tasksDto;
						if (this.rows.length > 0) {
							this.config = {
								itemsPerPage: 6,
								currentPage: 1,
								totalItems: this.rows.length
							};
							this.taskList = this.rows;
							this.showList = true;
						}
					} else {
						this.rows = [];
					}
				} else {
					this.rows = [];
				}
				this.loading = false;
			}, error => {
				this.rows = [];
				this.isError = true;
				this.alertType = HEC_CONSTANTS.ERROR_TYPES.error;
				this.errorMessage = HEC_CONSTANTS.MESSGAES_LIST.SOMETHING_LATER_ERROR;
				this.loading = false;
			})
	}

	ngOnDestroy(): void {
		this._onDestroy.next();
		this._onDestroy.complete();
	}

	public pageChanged(event) {
		this.config.currentPage = event;
	}

	public getDate(date) {
		if(date){
		let createDate;
		return createDate = this.sharedServices.getDate(date)
	}
	}

	// public getSelectedCategory(value){
	// 	if(value == 1 || value == 0){
	// 		this.loading = true;
	// 		this.taskList = []
	// 		this.cdr.detectChanges();
	// 		let appsList = [];
	// 		this.service.getLevelWiseApps(value).subscribe(
	// 			(res)=>{
	// 				if(res.statusCode == HEC_CONSTANTS.HTTP_RESPONSE.OK){
	// 					appsList = res.data;
	// 					console.log(appsList)
	// 					appsList.forEach(element => {
	// 						this.rows.forEach(rowsInd => {
	// 							if(element == rowsInd.applicationId){
	// 								this.taskList.push(rowsInd)
	// 							}
	// 						});
	// 					});
	// 				this.loading = false;
	// 				}else{
	// 				this.loading = false;

	// 				}
	// 			}
	// 		)

	// 	}
	// 	else if(value == 3){
	// 	this.taskList = [];
	// 	this.getTasks();
	// 	this.cdr.detectChanges();

	// }
		
	// }
}